export const getCompletionTone = (pct) => {
  if (pct >= 70) return "success";
  if (pct >= 50) return "warning";
  return "danger";
};

export const getOverdueTone = (pct) => {
  if (pct === 0) return "neutral";
  if (pct >= 19) return "danger";
  return "warning";
};

export const getOnTimeTone = (pct) => {
  if (pct >= 85) return "success";
  if (pct >= 60) return "warning";
  return "danger";
};

export const formatAvgHours = (hours) => `${Number(hours).toFixed(1)}h`;

export const formatOpenAge = (days) => `${days}d`;

export const formatTatDays = (days) => `${Number(days).toFixed(1)}d`;

export const formatDaysCount = (days) => `${days}d`;

export const formatHoursCount = (hours) => `${hours}h`;

export const formatAvgDaysLate = (days) => {
  if (days == null) return "—";
  const value = Number(days);
  const formatted = Number.isInteger(value) ? String(value) : value.toFixed(1);
  return `avg ${formatted}d late`;
};

export const getPriorityTone = (priority) => {
  const key = String(priority || "").toLowerCase();
  if (key === "critical") return "critical";
  if (key === "high") return "high";
  return "medium";
};
